import { ThemePageTypeEnum } from '@xshop/shared';
import type { PageType } from './registry';

// The page sets a section's taxonomy says it belongs on. Named once here so the builder's
// "you cannot put a COD form on a thank-you page" rule reads the same from every catalog entry.

/** Every page type a theme can define — for sections that make sense anywhere. */
export const ANY_PAGE: readonly PageType[] = ThemePageTypeEnum.options;

/** The pages that persuade: everything a shopper reads before and around the offer. */
export const SELLING_PAGES: readonly PageType[] = ['home', 'article', 'squeeze', 'product', 'product-cod', 'upsell', 'downsell'];

/** The pages a shopper browses the catalogue on. */
export const BROWSE_PAGES: readonly PageType[] = ['home', 'collection', 'article', 'squeeze', 'search', 'not-found'];

/** The two product pages: the classic one, and the cash-on-delivery one this market sells on. */
export const PRODUCT_PAGES: readonly PageType[] = ['product', 'product-cod'];

/** The pages that carry an order form and its money rows. */
export const ORDER_PAGES: readonly PageType[] = ['product-cod', 'checkout'];

/** The pages served after the order is placed. */
export const POST_PURCHASE_PAGES: readonly PageType[] = ['upsell', 'downsell', 'thankyou'];
